/**
 * Timer mixin
 *
 * Добавляет логику отсчета длительности
 *
 */

export default {
  staticData: () => ({
    isTimerStarted: false,
    isTimerPaused: false,
    timerStartTimestamp: null,
    timerAnimationFrame: null,
    timerDuration: 0,
  }),
  beforeDestroy() {
    window.cancelAnimationFrame(this.timerAnimationFrame);
  },
  methods: {
    startTimer() {
      if (this.isTimerStarted) return;
      this.isTimerStarted = true;
      this.timerStartTimestamp = performance.now();
      this.timerAnimationFrame = window.requestAnimationFrame(this.calculateTimer);
      this.onTimerStart?.();
    },
    stopTimer() {
      if (!this.isTimerStarted) return;
      this.isTimerStarted = false;
      this.onTimerStop?.(this.timerDuration);
      this.timerDuration = 0;
    },
    pauseTimer() {
      if (this.isTimerPaused) return;
      this.isTimerPaused = true;
      this.onTimerPause?.();
    },
    resumeTimer() {
      if (!this.isTimerPaused) return;
      this.isTimerPaused = false;
      this.timerStartTimestamp = performance.now() - this.timerDuration;
      this.timerAnimationFrame = window.requestAnimationFrame(this.calculateTimer);
      this.onTimerResume?.();
    },
    calculateTimer(timestamp) {
      if (this.isTimerPaused || !this.isTimerStarted) return;
      this.timerDuration = timestamp - this.timerStartTimestamp;
      this.timerAnimationFrame = window.requestAnimationFrame(this.calculateTimer);
      const value = this.getTimerPrettyValue(this.timerDuration);
      this.onTimerUpdate?.(value, this.timerDuration);
    },
    getTimerPrettyValue(timestamp) {
      if (timestamp <= 0) return '00:00';
      const duration = timestamp / 1000;
      const minutes = String(Math.floor(duration / 60)).padStart(2, '0');
      const seconds = String(Math.floor(duration % 60)).padStart(2, '0');
      return `${minutes}:${seconds}`;
    },
  },
};
